import img1 from '../.././Image/img1.jpg'
import img4 from '../.././Image/img4.PNG'
import img5 from '../.././Image/img5.PNG'
import img6 from '../.././Image/img6.jpg'
import img7 from '../.././Image/img7.PNG'
import img8 from '../.././Image/img8.PNG'
import img9 from '../.././Image/img9.jpg'
import img10 from '../.././Image/img10.PNG'
import img12 from '../.././Image/img12.png'
import img13 from '../.././Image/img13.png'
import img14 from '../.././Image/IMG_3176.PNG'
import img15 from '../.././Image/IMG_3186.PNG'
import img16 from '../.././Image/IMG_3187.PNG'
import img17 from '../.././Image/IMG_3189.PNG'
import img18 from '../.././Image/IMG_3190.PNG'

import img19 from '../.././Image/IMG_3191.PNG'
import img20 from '../.././Image/IMG_3192.PNG'




// import img14 from '../.././Image/img14.png'
// import img15 from '../.././Image/img15.png'


function All() {
    return (
        <>

            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-center place-items-center">


                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img9} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img12} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img7} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img1} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img5} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img10} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                {/* <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img8} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div> */}

                {/* <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img13} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div> */}

                {/* <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img7} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img4} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img6} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div> */}

                <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img8} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img14} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                  <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img15} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img16} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img17} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img18} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img19} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img20} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
            </div>


            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

                <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Brand & Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">

                   
                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                        hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Brand Identity Guidelines
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A document explaining how the company represents itself visually and verbally —
                            logo, colors, typography, and brand usage rules.
                        </p>
                    </div>

                   
                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
       q                 hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Corporate Brand Guidelines
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Formal branding rulebook created for internal teams & corporate collaboration to
                            maintain consistent brand identity across all platforms.
                        </p>
                    </div>

                 
                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                      hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Visual Identity Manual
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Detailed instructions on visual design — logo placement, colors, graphic elements,
                            imagery, layout rules, etc.
                        </p>
                    </div>

                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                      hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Brand Style Guide
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Defines the style, tone, and personality of the brand including communication style,
                            do’s & don’ts, and brand presentation.
                        </p>
                    </div>

                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                      hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Digital Brand Guidelines
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A complete guide for digital platforms including web, mobile apps, UI/UX components,
                            icons, and digital usage standards.
                        </p>
                    </div>

                    
                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                      hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Brand Book
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A compact overview of the brand’s identity, mission, vision, values, logo rules,
                            and design standards in one branded document.
                        </p>
                    </div>

                
                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                      hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Technology Design System
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Includes standardized UI/UX components, layout grid, spacing, typography, buttons,
                            color system for all tech products and web apps.
                        </p>
                    </div>

                    <div className="p-6 sm:p-7 md:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                           hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Corporate Identity Manual
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Explains brand visuals + behavior + documentation standards such as stationery,
                            marketing material, presentations, and digital banners.
                        </p>
                    </div>

                    <div className="p-6 sm:p-7 md:p-6 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                           hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Design System & Brand Identity
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A hybrid manual combining brand identity with reusable design system elements for
                            product and software teams.
                        </p>
                    </div>

                 
                    <div className="p-6 sm:p-7 md:p-6 rounded-2xl bg-white/10 backdrop-blur-xl shadow-xl 
                      hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px] mx-auto">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            IT Brand Strategy Guide
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A strategic document focusing on brand positioning, target audience, communication
                            tone, and branding implementation approach.
                        </p>
                    </div>

                </div>

            </div>



        </>
    );
}

export default All;